import styled, {keyframes} from 'styled-components';
import Image from '@stencil/image';
import {
  CenteredSpaceWrap,
  CenteredDivWrap,
  SectionHeader,
} from '../../../../CommonStyleUtils/dwebCommon.styles';
import {headingSizes, textSizes} from '@stencil/build-theme';

export const CaptivateBannerGalleryContainer = styled.div(
  props => `
  position:relative;
  display: flex;
  width: ${props.isSeoPage ? '100%' : '590px'};
  margin-left: 'auto';
    `,
);

export const CaptivateBannerGallery = styled.div(
  props => `
  position:relative;
  display:flex;
    `,
);

export const CaptivateMainImageWrapper = styled.div(
  props => `
  margin-right: 15px;
  width: ${props.isSeoPage ? '100%' : '590px'};
    `,
);

export const WideImageViewAllPhotosOuter = styled(CenteredDivWrap)(
  props => `
  position:relative;
  display: flex;
  min-width: 100%;
  // z-index: 999;
    `,
);

export const WideImageViewAllPhotos = styled(CenteredDivWrap)(
  props => `
  display:flex;
  flex-direction:column;
  height:75%;
  position: absolute;
  top: 14%;
  padding: ${props.theme.spacing.custom(16)};
  // background:${props.theme.colors.shadow.base};
  border-radius:${props.theme.misc.borderRadius.custom(20)};
  cursor:pointer;
    `,
);

export const WideImageViewAllBtn = styled.button`
  ${textSizes.MediumW3}
  border:none;
  background: ${props => props.theme.colors.downriver.base};
  color: ${props => props.theme.colors.goWhite.base};
  border-radius: ${props => props.theme.misc.borderRadius.xxxlarge};
  padding: ${props => props.theme.spacing.custom(16)};
  margin-right: ${props => props.theme.spacing.custom(23)};
  cursor: pointer;
  &:last-child {
    margin-right: 0;
  }
`;

export const ViewAllPhotosText = styled.span`
  ${headingSizes.MediumW1}
  color:${props => props.theme.colors.goWhite.base};
  padding-top: ${props => props.theme.spacing.custom(35)};
`;

export const WideImagePreviewWrap = styled.div(
  props => `
  display:flex;
  flex-direction:column;
  // pointer-events: none;
  cursor: pointer;

    width: ${props.isSeoPage ? 'calc(98% - 420px)' : '585px'}; 
    position: absolute;
    top: 0;
    justify-content: space-between;
    height: 100%;
    padding: ${props.theme.spacing.custom(16)};
    `,
);

export const HappyAngleRightIconWrap = styled(CenteredDivWrap)(
  props => `
    width:2.4rem;
    height:2.4rem;
    border-radius:${props.theme.misc.borderRadius.round};
    background:${props.theme.colors.goWhite.base};
    cursor: pointer;
    border: .1rem solid ${props.theme.colors.downriver.base};
    `,
);

export const CaptivateGalleryImageBasic = styled.img(
  props => `
  width:100%;
  height:${props.isSeoPage ? '46rem' : '32rem'};
  object-fit: cover;
  border-radius:${props.theme.misc.borderRadius.xxxlarge};
  min-width: ${props.listItemWidth || '50%'};
    `,
);

export const CaptivateGalleryImage = styled(Image)(
  props => `
  width:100%;
  height:${props.isSeoPage ? '46rem' : '32rem'};
  object-fit: cover;
  border-radius:${props.theme.misc.borderRadius.xxxlarge};
  min-width: ${props.listItemWidth || '50%'};
    `,
);

export const LeftIconWrapper = styled.div(
  props => `
    position: absolute;
    left: 1.6rem;
    top: 50%;
  `,
);

export const CaptivateImageWrapper = styled.div(
  props => `
  width:100%;
  height:32rem;
  min-width: ${props.listItemWidth || '100%'};
  position: relative;
    `,
);

export const CaptivateBannerOuterContainer = styled.div(
  props => `
  overflow: hidden;
  position: relative;
    `,
);

export const CaptivateGalleryImageViewAll = styled(CaptivateGalleryImage)(
  props => `
  filter: blur(2px);
  height: ${props.isSeoPage ? '' : '350px'};
    `,
);

export const CaptivateGalleryOverlayTabWrap = styled.div(
  props => `
  display:flex;
  justify-content: flex-end;
  cursor: pointer;
    `,
);

export const CaptivateGalleryOverlayTab = styled.div(
  props => `
  display:flex;
  border-radius:${props.theme.misc.borderRadius.base};
  background:${props.theme.colors.shadow.dark};
  padding: ${props.theme.spacing.small};
  margin-right:${props.theme.spacing.custom(12)};
  &:last-child{
    margin-right:0;
  }
  >p{
    font-weight: 600;
    color:${props.theme.colors.goWhite.base};
    user-select:none;
  }
    `,
);

export const CaptivateBannerGalleryRoomTagContainer = styled.div(
  props => `
  max-width:30%;
  text-align:center;
  margin-right:${props.theme.spacing.custom(18)};
    `,
);

export const CaptivateBannerGalleryRoomTYpeTag = styled.div`
  color: ${props => props.theme.colors.goWhite.base};
  margin-bottom: ${props => props.theme.spacing.custom(8)};
  &.selectedTag {
    ${textSizes.MediumW3}
    color:${props => props.theme.colors.goYellow.base};
  }
`;

export const CaptivateProgressBarWrap = styled.div(
  props => `
  height: .2rem;
  position: relative;
  border-radius:${props.theme.misc.borderRadius.xxxlarge};
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000 86%);
  overflow: hidden;
  span{
    display: block;
    height: 100%;
    width:100%;
  }
    `,
);

const progressBar = keyframes`
    0%   { width: 0; }
    100%  { width: 100; }
`;

export const CaptivateProgressBarAnimate = styled.span`
  &.selectedProgressBar {
    background: ${props => props.theme.colors.goYellow.base};
  }
  animation-name: ${progressBar};
  animation-fill-mode: both;
  animation-duration: 3s;
  animation-timing-function: ease-in-out;
`;

export const ImageItemWrapperLastSlide = styled.div(
  props => `
    width: 192px;
    position: relative;
    margin-bottom: 10px;
    margin-right:${props.marginRight || ''};
    cursor: pointer;
    > img {
      object-fit: cover;
      width: 192px;
    height: 126px;
    border-radius: 12px;
    }  `,
);

export const ItemInfoWrapper = styled.div(
  props => `
    position: absolute;
    width: 100%;
    padding: 10px 12px;
    display: flex;
    align-items:center;
    justify-content: space-between;
    background: linear-gradient(176.87deg, rgba(0, 0, 0, 0.36) 0.97%, rgba(0, 0, 0, 0.9) 95.79%);
    backdrop-filter: blur(4px);
    bottom: ${props.bottom || 0};
    border-radius: 0 0 8px 8px;
    `,
);

export const ItemInfoWrapperLarge = styled.div(
  props => `
    position: relative;
    width: 100%;
    left : 0;
    padding: 16px 20px;
    display: flex;
    align-items:center;
    justify-content: space-between;
    background: linear-gradient(176.87deg, rgba(0, 0, 0, 0.36) 0.97%, rgba(0, 0, 0, 0.9) 95.79%);
    backdrop-filter: blur(4px);
    bottom: 0px;
    border-radius: 0 0 8px 8px;
    margin-top: -48px;
    
    `,
);

export const InfoLeftSection = styled.div(
  props => `
    p {
      font-size: 12px;
      color: ${props.theme.colors.goWhite.base};
    }
    `,
);

export const InfoRightSection = styled.div`
  ${textSizes.BaseW3}
  display : flex;
  align-items: center;
  color: #fff;
  & svg {
    margin-left: 6px;
  }
`;

export const ImageControlWrapper = styled(CenteredSpaceWrap)(
  props => `
  flex: ${props.hasSoldOut ? '1' : 'auto'};
    `,
);

export const ImageRightSectionWrapper = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    margin-right: ${props.isSeoPage ? '0' : '2rem'};
    justify-content: flex-start;
    ${props.width ? `width: ${props.width};` : ''}
    `,
);

export const ImageItemWrapper = styled.div(
  props => `
  width:  ${props.isSeoPage ? '404px' : '232px'};
  height: ${props.isSeoPage ? '220px' : `${props.imageHeight || '168px'}`};
    position: relative;
    margin-bottom: ${props.marginBottom || '14px'};
    margin-top:${props.marginTop || ''};
    cursor: pointer;
    border-radius: 12px;
    overflow:hidden;
    > img {
      object-fit: cover;
      width: ${props.isSeoPage ? '404px' : '232px'};
      height: ${props.isSeoPage ? '220px' : '156px'};
      border-radius: 12px;
    }
    >svg{
      position:absolute;
      left: 41%;
      top: 28%;
    }
    > div {
      height:${props.isVideo ? '100%' : ''};
     > video{
      height:100% !important;
      object-fit:fill;
      padding:0 !important;
      border-radius: 0 ;
    }
  }
    `,
);

export const IconWrapper = styled.div`
  height: 200px;
  padding-top: 78px;
`;
